<template>
    <div class="board-root h-full board-container" ref="board-view">
        <div v-if="!boardsPreload" class="loading-tasks">
            {{ taskLoadingText }} <LoaderAnimationVue v-if="taskLoadingText = 'Loading Tasks'" color="#fff" />
        </div>
        <div v-else-if="(!boardLists || boardLists?.length == 0) && boardsPreload && activeBoard" class="add-first-list">
            <VButton v-if="!showNewListField" @clickHandler="focusNewListTextfield('newListTextfield1')" :fullWidth="true">
                + Add List
            </VButton>
            <form @submit.prevent="createList(true)" v-if="showNewListField">
                <Textfield
                    :id="'newListTitle'"
                    v-model="newList.title"
                    :placeholder="'List name'"
                    ref="newListTextfield1"
                />
                <div class="new-list-btns">
                    <VButton
                        @clickHandler="createList(true)"
                        :class="createListButtonDisabled ? 'cursor-not-allowed' : ''"
                        :disabled="createListButtonDisabled"
                    >
                        Create
                    </VButton>
                    <VButton @clickHandler="showNewListField = false, newList.title = ''">
                        Cancel
                    </VButton>
                </div>
            </form>
        </div>
        <BoardContainer
            v-else
            ref="board-container"
            :boardOverviewFunc="boardOverviewFunc"
            @onEditList="onEditList"
            @setVariable="setVariable"
            :board_id_from_task="board_id_from_task"
            :task="task"
            :filterByTag="filterByTag"
            :tags="tags"
            :events="events"
            :list="list"
            :edit_modal_toggle="edit_modal_toggle"
            :cacheTimerRenewLock="cacheTimerRenewLock"
            :from_task="from_task"
            @fromTaskFalse="fromTaskFalse"
            :board_id="board_id"
            @closeModalEditTask="closeModalEditTask"
            @showUploadState="showUploadState"
        >
            <Container
                class="lists"
                orientation="horizontal"
                drag-class="card-ghost"
                drop-class="card-ghost-drop"
                :drop-placeholder="upperDropPlaceholderOptions"
                @drop="listDrop($event)"
            >
                <Draggable
                    v-for="(listItem, listIndex) in boardListsFiltered"
                    :key="listIndex"
                    class="item item-list"
                    :class="'list' + listIndex"
                    :id="listItem.id"
                >
                    <!-- Removed: :boardIndex="boardIndex", :boardId="board.id" props -->
                    <TaskListContainer
                        @mouseover="mouseoverList(listItem.id)"
                        :listTitle="listItem.title"
                        :tasks="formattedTasks(listItem.tasks)"
                        :listItem="listItem"
                        @openEditTask="openEditTask"
                        :extendedList="true"
                        :list="list"
                        @createTask="createTask"
                        @cancelCreatingTask="cancelCreatingTask"
                        @toggleNewTaskTemplates="toggleNewTaskTemplates"
                        @openNewCardModal="openNewCardModal"
                        :listIndex="listIndex"
                        @toggleListOptionsPopUp="toggleListOptionsPopUp"
                        @openEditModal="openEditModal"
                        @archiveList="showArchiveListModal"
                        @setCardPayload="setCardPayload"
                        @dragstart="dragstart"
                        @onCardDrop="onCardDrop"
                    />
                </Draggable>
                <div v-if="boardLists && boardLists.length > 0" class="item-list">
                    <div class="add-list w-250px">
                        <VButton
                            v-if="!showNewListField"
                            @clickHandler="focusNewListTextfield('newListTextfield2')"
                            fullWidth
                        >+ Add List</VButton>
                        <form @submit.prevent="createList(false)" v-if="showNewListField">
                            <Textfield
                                :id="'newListTitle'"
                                v-model="newList.title"
                                :placeholder="'List name'"
                                ref="newListTextfield2"
                            />
                            <div class="new-list-btns">
                                <VButton
                                    @clickHandler="createList(false)"
                                    :class="createListButtonDisabled ? 'cursor-not-allowed' : ''"
                                    :disabled="createListButtonDisabled"
                                >
                                    Create
                                </VButton>
                                <VButton @clickHandler="showNewListField = false, newList.title = ''">
                                    Cancel
                                </VButton>
                            </div>
                        </form>
                    </div>
                </div>
            </Container>
        </BoardContainer>
        <div v-if="boardLists?.length === 0 && boardsPreload" class="smart-list-card-wrap">
            <div class="smart-list-card">
                <h2>Welcome</h2>
                <p>
                    Welcome to your new home, take a ride by watching the following video.
                </p>
                <div class="smart-list-video">
                    <iframe 
                        width="100%" 
                        height="100%" 
                        src="https://www.youtube.com/embed/nPXdlwVk0G0?si=AMdflcFBg2VRmB38" title="YouTube video player" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowfullscreen>
                    </iframe>
                  </div>
            </div>
        </div>
        <ConfirmDelete
            ref="archive-list-modal"
            id="archive-list-modal"
            :title="`${archiveListObj?.title} list`"
            :archiveType="true"
            @delete="archiveList()"
        />
        <Flash ref="show"/>
        <VModal title="Import Tasks" ref="import-modal" class="import-modal" size="lg" :flexheight="true" @hideModal="$store.dispatch('setImportCSV', null)">
            <ImportCSV />
        </VModal>
    </div>
</template>

<script>
import {api, tab_uuid} from "@/mixins/axios";
import {Container, Draggable} from "vue-smooth-dnd";
import {applyDrag, difference, getTagsAsArray} from "@/mixins/helpers";
import Flash from "@/components/Flash.vue";
import VButton from "@/components/atoms/VButton";
import BoardContainer from "@/components/containers/BoardContainer.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import TextArea from "@/components/atoms/TextArea.vue";
import EventsCard from "@/components/molecules/EventsCard.vue";
import { mapActions, mapState } from 'vuex';
import Dropmenu from "@/components/atoms/Dropmenu.vue";
import ConflictSavingModal from "@/components/molecules/ConflictSavingModal.vue";
import TaskCard from "@/components/atoms/TaskCard.vue";
import TaskListContainer from "@/components/containers/TaskListContainer.vue";
import ConfirmDelete from "@/components/organism/Confirm.vue";
import LoaderAnimationVue from "@/components/atoms/LoaderAnimation.vue";
import { set } from 'vue';
import ImportCSV from "@/components/molecules/ImportCSV.vue";
import VModal from "@/components/atoms/VModal.vue";

export default {
    name: "Project",
    components: {
        VButton,
        Container,
        Draggable,
        Flash,
        BoardContainer,
        Textfield,
        TextArea,
        EventsCard,
        Dropmenu,
        ConflictSavingModal,
        TaskCard,
        TaskListContainer,
        ConfirmDelete,
        LoaderAnimationVue,
        ImportCSV,
        VModal
    },
    props: ["board_id", "token", "dragScroll", "clearFilter", "boardOverviewFunc", "tasksIntervalRun"],
    data: function () {
        return {
            upperDropPlaceholderOptions: {
                className: "cards-drop-preview",
                animationDuration: "150",
                showOnTop: true,
            },
            dropPlaceholderOptions: {
                className: "drop-preview",
                animationDuration: "150",
                showOnTop: false,
            },
            task: {
                id: "",
                title: "",
                body: "",
                tags: [],
                tags2: [],
                is_template: false,
            },
            setAtags: [],
            setBtags: [],
            task_payload: {},
            member: {
                email: "",
                role: "member",
                project: "",
            },
            events: [],
            cacheTimerRenewLock: null,
            board: {
                title: "",
            },
            newBoard: {
                title: "",
            },
            searchTag: "",
            lock: "",
            newList: {
                title: "",
            },
            list: {
                title: "",
                tags: [],
                listIndex: "",
                boardIndex: "",
                listPosition: "",
                openListOptions: false,
                openNewTask: false
            },
            tags: [],
            edit_modal_toggle: false,
            is_template: false,
            list_id: "",
            to_time: null,
            list_task_drop_result: {},
            showNewListField: false,
            createBoardTitle: '',
            from_task: false,
            board_id_from_task: null,
            addTaskTitle: '',
            archiveListObj: null,
            boardsPreload: false,
            taskLoadingText: 'Loading Tasks',
            page: 1,
            boardListsFiltered: null,
            projectOrder: [],
            newTasks: [],
        };
    },
    computed: {
        tagSearchResult() {
            if (this.searchTag) {
                const search_result = this.tags.filter((item) => {
                    return this.searchTags.every((tag) =>
                        item[2].toLowerCase().includes(tag),
                    );
                });
                return search_result
            }

            return this.tags;
        },
        searchTags() {
            return this.searchTag.toLowerCase().split(" ");
        },
        currentUser() {
            return this.$store.getters.currentUser
        },
        createListButtonDisabled() {
            return this.newList.title == "";
        },
        ...mapState(['userFilter']),
        boards() {
            return this.$store.getters.boards
        },
        templateTasks() {
            return this.$store.getters.templateTasks
        },
        userID() {
            return this.$store.getters.userID
        },
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        boardLists() {
            return this.$store.getters.activeBoardTasks
        },
        events2() {
            return this.$store.getters.events2
        },
        editableTask() {
            return this.$store.getters.editableTask
        },
        users() {
            return this.$store.getters.users
        },
        tagFilter() {
            return this.$store.getters.tagFilter
        },
        allTags() {
            return this.$store.getters.tags
        },
        usersMap() {
            return new Map(this.users?.map(user => [user?.id, user]))
        },
        tagMap() {
            return new Map(this.allTags?.map(tag => [tag?.id, tag]))
        },
        importCSVTasks() {
            return this.$store.getters.importCSVTasks
        }
    },
    async mounted() {
        // DRAGSCROLL LOGIC
        this.dragScroll()
        
        if(this.$route.name == 'TaskModal') {
            const taskInfoFromRoute = this.$route.params.taskInfo
            const taskID = parseInt(taskInfoFromRoute.split('-')[taskInfoFromRoute.split('-').length - 1])
            try {
                const response = await api.post("/task_search", {id: taskID});
                if (response.data.msg == 'ok') {
                    const taskInfo = response.data.data[0]
                    this.$store.dispatch('setActiveBoard', taskInfo.project_id)
                    
                    const list_response = await api.post("/list_search", {id: taskInfo.list_id});
                    if (list_response.data.msg === 'ok') {
                        const listInfo = list_response.data.data[0]
                        this.from_task = true

                        setTimeout(async () => {
                            await this.tasksSearch();
                            await this.tagsSearch();

                            let tags = null;
                            tags = taskInfo && taskInfo?.tags ? taskInfo.tags.map(tag => {
                                let t = tag.split(':')
                                return {
                                    tagType: t[0],
                                    id: Number(t[1])
                                }
                            }).filter(tag => tag.id).map(tag => {
                                if(tag.tagType == 'user') {
                                    return {
                                        tagType: tag.tagType,
                                        ...this.usersMap.get(tag.id)
                                    }
                                }
                                if(tag.tagType == 'tag') {
                                    return {
                                        tagType: tag.tagType,
                                        ...this.tagMap.get(tag.id)
                                    }
                                }
                            }) : []

                            taskInfo.tags = tags

                            this.openEditTask(taskInfo, listInfo)
                        }, 500)
                    }
                }
            } catch (e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message )
            }
        } else {
            this.getTags()
            await this.tasksSearch();
        }
    },
    methods: {
        tasksInterval(event, afterLoad) {
            if (event.tab_id == tab_uuid) return

            if(event.type == 'move_task' && afterLoad == -1) {
                event.type = 'move_task_init'
            }
            if((event.type == 'new_task' || event.type == 'new_list' || event.type == 'move_list') && afterLoad == -1) {
                event.type = 'init'
            }
            
            //SSE UPDATES NEEDS FOR ALL RELATED FUNCTIONS
            const mapper = {
                "edit_task_title": 'updateTaskTitleEvent',
                "edit_task_body": 'updateTaskDescriptionEvent',
                "edit_task_tags": 'updateTaskTagsEvent',
                "new_task": 'handleNewTaskEvent',
                "move_task": 'handleTaskMoveEvent',
                "move_task_init": 'handleTaskActivityEvent',
                "comment": 'handleTaskActivityEvent',
                "upload": 'handleTaskActivityEvent',
                "new_list": 'handleNewListEvent',
                "archive_list": 'handleArchiveListEvent',
                "move_list": 'handleMoveListEvent',
                "logwork": 'handleTaskActivityEvent',
                "edit_list_title": 'handleEditListTitle',
                "user_edit": 'handleUserEdit',
                "archive_task": 'handleArchiveTaskEvent',
                'init': 'handleInit'
            }

            try {
                this[mapper[event['type']]](event)
            } catch(e) {}
        },
        handleInit(e) {
        },
        focusNewListTextfield(el) {
            this.showNewListField = true;
            this.$nextTick(() => {
                this.$refs[el].$el.querySelector('input.textfield').focus();
                this.$refs[el].$el.querySelector('input.textfield').scrollIntoView()
            })
        },
        handleUserEdit(event) {
            let data = {
                user_id: event.user_id,
                username: event.txt1,
                name: event.txt2,
                portrait: event.txt4,
                bio: event.txt3
            }
            this.$store.dispatch('updateMember', data)
        },
        handleMoveListEvent(event) {
            if(event.project_id != this.activeBoard.id) return

            let data = {
                project_id: event.project_id,
                list_id: event.list_id,
                prev_list_id: event.uint1
            }
            this.$store.dispatch('switchBoardLists', data)

            this.filterByTag()
        },
        handleNewListEvent(event) {
            let list = {
                id: event.list_id,
                title: event.txt1,
                tasks: []
            }
            this.$store.dispatch('addActiveBoardList', list)
            this.filterByTag()
        },
        handleArchiveListEvent(event) {
            this.$store.dispatch('removeList', event.list_id)
            this.filterByTag()
        },
        handleTaskMoveEvent(event) {
            if(event.project_id != this.activeBoard.id) return

            let data = {
                list_id: event.list_id,
                task_id: event.task_id,
                prev_task_id: event.uint1
            }
            this.$store.dispatch('moveActiveBoardTask', data)
            this.handleTaskActivityEvent(event)
            this.filterByTag()
        },
        handleTaskActivityEvent(event) {
            this.$store.dispatch('editTaskEvents', event)
            const isForCurrentUser = event.unseen.filter(id => id == this.currentUser.id)
            if (isForCurrentUser.length > 0) {
                const board = this.boards.filter(board => board.id == event.project_id)
                this.updateProjectData(board[0].notif_count, event.project_id)
            }

            this.filterByTag()
            this.$forceUpdate()
        },
        handleArchiveTaskEvent(event) {
            const newTask = {
                id: event.task_id,
                title: event.txt1,
                project_id: event.project_id,
                list_id: event.list_id,
            };

            this.$store.dispatch('removeActiveBoardTask', newTask)
            this.filterByTag()
        },
        handleNewTaskEvent(event) {
            let tasks = this.boardListsFiltered.flatMap(list => list.tasks);
            if(tasks.map(task => task.id).includes(event.task_id)) return

            const newTask = {
                id: event.task_id,
                title: event.txt1,
                project_id: event.project_id,
                list_id: event.list_id,
                body: '',
                body_html: '',
                is_template: false,
                tags: "||"
            };

            this.$store.dispatch('addActiveBoardTask', newTask)
            this.filterByTag()
        },
        handleEditListTitle(event) {
            this.$store.dispatch('editActiveBoardList', {title: event.txt1, list_id: event.list_id})
        },
        updateTaskTitleEvent(event) {
            this.$store.dispatch('editTask', {
                title: event.txt1,
                list_id: event.list_id,
                id: event.task_id
            })
            this.filterByTag()
        },
        updateTaskDescriptionEvent(event) {
            this.$store.dispatch('editTaskDescription', {
                body: event.txt1,
                body_html: event.txt1_html,
                list_id: event.list_id,
                id: event.task_id
            })
            this.filterByTag()
        },
        updateTaskTagsEvent(event) {
            let tags = getTagsAsArray({tags: event.txt1.split('|').filter(i => i != '')}, this.usersMap, this.tagMap)

            this.$store.dispatch('editTaskTags', {
                tags: tags,
                list_id: event.list_id,
                id: event.task_id
            })

            this.handleTaskActivityEvent(event)

            this.filterByTag()
        },
        renewLock() {
            this.cacheTimerRenewLock = setInterval(() => {
                if (this.edit_modal_toggle) {
                    this.lockTaskRenew();
                }
            }, 20000);
        },
        clearList() {
            this.newList.title = ""
        },
        openEditModal(modalId) {
            this.$refs['board-container']?.$refs[modalId].showModal()
        },
        hideEditModal(modalId) {
            this.$refs['board-container'][0].$refs[modalId].hideModal()
        },
        clearTask() {
            this.task = {
                title: "",
                body: "",
                tags: [],
            };
        },
        openNewCardModal(list, listIndex, boardIndex, boardId, template) {
            this.clearTask();
            this.searchTag = "";
            this.addTaskTitle = "";
            this.list = list;
            this.list.boardId = boardId;
            this.list.boardIndex = boardIndex;
            this.list.listIndex = listIndex;
            this.$set(this.list, 'newTask', true)
            if (template) {
                this.task['body'] = template.body
                this.task['tags'] = template.tags
            }

            setTimeout(() => {
                document.querySelector(`.list${listIndex}`).querySelector('#new_task_title').focus();
            }, 100);

            this.$forceUpdate()
        },
        cancelCreatingTask() {
            this.list.newTask = false;
            this.clearTask();
        },
        async closeModalEditTask() {
            this.$store.dispatch('editTask', this.editableTask);
            this.edit_modal_toggle = false
            clearInterval(this.cacheTimerRenewLock)

            let newURLSegment = `/project/${this.editableTask.project_id}`;
            this.$router.push(newURLSegment).catch((e) => {});

            const board = this.boards.filter(board => board.id === this.board_id_from_task)[0]
            document.title = board && board.title ? `${board.title} | Goleko` : 'Goleko'

            this.filterByTag()
        },
        async openEditTask(task, list) {
            this.task = JSON.parse(JSON.stringify(task))
            this.$store.dispatch('setEditableTask', this.task);
            this.$set(this, 'board_id_from_task', task.project_id)
            
            setTimeout(() => document.title = this.task && this.task.title ? `${this.task.title} | Goleko` : 'Goleko', 500)

            if (list) {
                this.$set(this, 'list', list)
            }
            this.getTags()

            // Couldn't this be done via vue router?
            var newURLSegment = `/app/tasks/${this.titleToSlug(task.title)}-${task.id}`;
            var currentState = history.state || {};
            currentState.urlSegment = newURLSegment;
            history.pushState(currentState, '', newURLSegment);

            this.searchTag = "";

            this.openEditModal('edit-task')

            try {
                const response = await api.post(`/task_open`, {id: task.id});
                if (response.data.msg == 'ok') {
                    this.$store.dispatch('setTaskTimeTracker', response.data.data)
                    this.updateProjectData(response.data.notif_count, response.data.project_id)
                }

            } catch (e) {
                console.error(e);
            }
        },
        updateProjectData(notif_count, project_id) {
            const updatedBoards = this.boards.map(board => board.id == project_id ? {...board, notif_count: notif_count} : board)
            this.$store.dispatch('setBoards', updatedBoards);
        },
        setCardPayload(payload) {
            console.log(payload)
            this.listsIds = []
            this.task_payload = payload;
        },
        toggleListOptionsPopUp(list, listIndex, boardIndex) {
            this.list = JSON.parse(JSON.stringify(list))
            //this.list = list
            this.list.listPosition = list.id;
            this.list.title = list.title;
            this.list.listIndex = listIndex;
            this.list.boardIndex = boardIndex;
            this.$set(list, 'openListOptions', true)
            //list.openNewTask = false;
            this.$forceUpdate();
        },
        toggleNewTaskTemplates(list, listIndex, boardIndex) {
            this.list = list
            this.list.listPosition = list.id;
            this.list.title = list.title;
            this.list.listIndex = listIndex;
            this.list.boardIndex = boardIndex;
            this.$set(this.list, 'openNewTask', true)
            this.$set(list, 'openListOptions', false)
            this.$forceUpdate();

            this.showNewListField = false
            this.newList.title = ''
        },
        listPosition(list, listIndex, boardIndex) {
            this.list.listPosition = list.id;
            this.list.title = list.title;
            this.list.listIndex = listIndex;
            this.list.boardIndex = boardIndex;
            return;
        },
        async listDrop(dropResult) {
            const {addedIndex} = dropResult
            const dragResult = applyDrag(this.boardListsFiltered, dropResult);
            let previousListIndex = null
            let previousListId = ""

            function returnListId(addedIndex) {
                if (addedIndex === 0) {
                    return null
                }
                previousListIndex = addedIndex - 1
                return dragResult[previousListIndex]?.id
            }

            previousListId = returnListId(addedIndex)

            const data = {
                id: dragResult[addedIndex].id,
                prev_list_id: previousListId
            };

            try {
                const response = await api.post(`/list_move`, data);
                if (response.status === 200) {
                    let data = {
                        list_id: dragResult[addedIndex].id,
                        prev_list_id: previousListId
                    }
                    this.$store.dispatch('switchBoardLists', data)
                }

            } catch (e) {
                console.error(e);
            }
        },
        mouseoverList(id) {
            // get id of hovered list
            this.list_id = id
        },

        dragstart(dragResult) {
            const {isSource, payload} = dragResult
            if (isSource) {
                this.list_task_drop_result = payload
            }
        },
        async onCardDrop(list, dropResult) {
            //WHEN YOU MOVE A CARD INSIDE 1 COLUMN - IT CALLED ONCE
            //WHEN YOU MOVE A CARD FROM ONE COLUMN TO ANOTHER - IT'S CALLED TWICE, FOR EVERY COLUMN, AND IN ONE REQUEST removedIndex IS NULL AND IN OTHER - addedIndex IS NULL
            const {removedIndex, addedIndex} = dropResult
            if (removedIndex === addedIndex) {
                return
            }
            if (removedIndex === null && addedIndex === null) {
                return
            }
            
            const newList = JSON.parse(JSON.stringify(list));
            let previousTaskIndex = null
            let previousTaskId = ""
            let previousTaskListId = ""
            newList.tasks = applyDrag(newList.tasks, dropResult);

            function returnTaskId(addedIndex) {
                if (addedIndex === 0) {
                    return null
                }
                previousTaskIndex = addedIndex - 1
                previousTaskListId = newList.tasks[previousTaskIndex]?.list_id
                return newList.tasks[previousTaskIndex]?.id
            }

            if (addedIndex === null) {
                return
            }

            previousTaskId = returnTaskId(addedIndex)

            if(this.userFilter != 'no-filter' || this.tagFilter != 'no-filter') {
                previousTaskId = null
            }
            
            try {
                const data = {
                    id: dropResult.payload?.id,
                    list_id: previousTaskListId || this.list_id,
                    prev_task_id: previousTaskId
                }
                
                this.$store.dispatch('moveActiveBoardTask', {
                    list_id: data.list_id,
                    task_id: data.id,
                    prev_task_id: data.prev_task_id
                })
                this.filterByTag()

                const response = await api.post(`/task_move`, data);
                if (response.data.msg == 'ok') {
                    
                }

            } catch(e) {
                console.log(e?.response?.msg || e?.message || 'something wrong');
            }

            // const updateBoardListInsideTask = (data, id, newBoardList) => {
            //     const objectToUpdate = data.find(obj => obj.id == id);
            //     if (objectToUpdate) {
            //         objectToUpdate.board_list = newBoardList;
            //     }
            // };
            // updateBoardListInsideTask(newList.children, this.task_payload.id, this.list_id);
        },
        async createList(firstList) {
            const data = {
                project_id: Number(this.board_id),
                title: this.newList.title,
                //order
            };

            try {
                const response = await api.post(`/list_new`, data);

                if (response.status === 200) {
                    this.clearList();
                    if (firstList) { this.showNewListField = true }
                    
                    this.focusNewListTextfield('newListTextfield2')
                    // this.showNewListField = false
                    
                    this.$store.dispatch('addActiveBoardList', {
                        id: response.data.data['id'],
                        prev_list_id: response.data.data['prev_list_id'],
                        title: response.data.data['title'],
                        tasks: []
                    });
                    this.filterByTag()
                }
            } catch (e) {
                this.$refs.show.showFlashError(e.response.data.msg)
                console.error(e);
            }
        },
        async getTags() {
            if (!this.activeBoard) return
            if (this.board_id && this.boards && !this.from_task) {
                const currentBoard = this.activeBoard
                this.tags = currentBoard && currentBoard?.members
            } else {
                const currentBoard = this.activeBoard
                this.tags = currentBoard && currentBoard?.members
            }
        },
        async createTask(addTaskTitle) {
            if(!addTaskTitle?.trim()) {
                this.$refs.show.showFlashError('Please insert task title')
                return
            }

            const {title, tags, body} = this.task;
            const data = {
                title: addTaskTitle,
                project_id: this.activeBoard.id,
                list_id: this.list.id,
                body,
                tags: tags ? tags.toString() : ''
            };

            try {
                const response = await api.post(`/task_new`, data);
                if (response.status === 200) {

                    if (response.data.data.id) {
                        this.$store.dispatch('addActiveBoardTask', response.data.data);
                        this.newTasks.push(response.data.data)
                        this.filterByTag()
                    }

                    // this.openNewCardModal(this.list, this.list.listIndex, this.list.boardIndex, this.list.boardId)
                }
            } catch (e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || 'Something went wrong')
                console.error(e);
                if(e.response.status === 402) {
                    this.$store.dispatch('updatePlanLimit', 'adding tasks');
                }
            }
        },
        async lockTaskRenew() {
            if (!this.lock) return;
            if (this.edit_modal_toggle === false) return;

            const {id} = this.task;
            const data = {
                id,
                seconds: 20,
                lock_id: this.lock,
            };

            try {
                const response = await api.post(`/task_renew_lock`, data);
            } catch (e) {
                console.error(e);
                clearInterval(this.cacheTimerRenewLock);
                if (!api.online) {
                    this.$refs.show.showFlashWarning(
                        "Lost connection, can't guarantee saving",
                    );
                }
            }
        },
        async lockTask() {
            if (!api.online) {
                this.$refs.show.showFlashWarning(
                    "Lost connection, can't guarantee saving",
                );
                return;
            }
            const {id} = this.task;
            const data = {id, seconds: 20};
            try {
                const response = await api.post(`/task_lock`, data);
                if (response.data.msg === "ok") {
                    this.edit_modal_toggle = !this.edit_modal_toggle
                    this.lock = response.data.lock;

                    this.task.body = response.data.body;

                    if (this.lock) {
                        this.renewLock();
                    }
                }
            } catch (e) {
                if (e.response.data.lock_user) {
                    clearInterval(this.cacheTimerRenewLock)
                    this.edit_modal_toggle = false
                    // TODO use user name instead
                    this.$refs.show.showFlashWarning(`Already locked by ${e.response.data.lock_user || "Unknown user"}`);
                } else {
                    this.$refs.show.showFlashError(e.response.data.msg);
                }
            }
        },
        async tasksSearch() {
            if (!this.activeBoard) {
                this.boardsPreload = true
                this.$store.dispatch('setActiveBoardTasks', [])
                return
            }
            try {
                let data = {
                    project: this.activeBoard['id'],
                    paginate_by: 2000,
                    detailed: true
                };
                this.$store.dispatch('setActiveBoardTasks', [])
                // if(data['detailed']) {
                //     data['paginate_by'] = 30
                // } else {
                //     this.page = 1
                // }

                data['page'] = this.page
                const response = await api.post(`/task_overview`, data);

                if(response.status === 200) {
                    if(!this.boardsPreload) {
                        this.boardsPreload = true
                    }
                    // this.$store.dispatch('extendTasks', JSON.parse(JSON.stringify(response.data.data)))

                    this.to_time = response.data.to_time
                    
                    const a = this.boards && this.boards.length && this.boards?.filter(board => board?.id == this.board_id)[0]
                    document.title = a && a.title ? `${a.title} | Goleko` : 'Goleko'

                    // if(this.boardsPreload && response.data.paginate_by * response.data.page < response.data.no_objects) {
                    //     this.page++
                    //     this.tasksSearch()
                    // }
                    this.$store.dispatch('setActiveBoardTasks', JSON.parse(JSON.stringify(response.data.data)))

                    if(!this.tasksIntervalRun) this.$emit('eventsSubscribtion')
                    else {
                        this.events2.forEach(event => (this.tasksInterval(event)))
                    }

                    this.$store.dispatch('setTemplateTasks', response.data.data.map(list => list.tasks).flat(1).filter(t => t.is_template))

                    this.tagsSearch();
                    this.filterByTag()
                }
            } catch (e) {
                console.log(e);
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message )
                this.boardsPreload = true
            }
        },
        compareDates(d1, d2) {
            let date1 = new Date(d1).getTime();
            let date2 = new Date(d2).getTime();
            
            if (date1 < date2) return 1
            else if (date1 > date2) return -1
            else return 0
        },
        async tagsSearch() {
            try {
                let data = {
                    project_id: this.activeBoard['id'],
                    paginate_by: 2000
                };

                const response = await api.post(`/tag_search`, data);

                if(response.status === 200) {
                    this.$store.dispatch('setTags', response.data.data)
                }
            } catch (e) {
                console.log(e);
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message )
            }
        },
        titleToSlug(title) {
            let slug = title.toLowerCase();

            slug = slug.replace(/\s+/g, '-');
            slug = slug.replace(/[^a-z0-9\-]/g, '');
            slug = slug.replace(/-+/g, '-');
            slug = slug.replace(/^-+|-+$/g, '');

            return slug;
        },
        async onEditList() {
            await this.boardOverviewFunc()
            await this.tasksSearch();
            await this.getTags();
        },
        setVariable(key, val) {
            this[key] = val
        },
        showArchiveListModal(list) {
            this.$refs['archive-list-modal'].$refs['archive-list-modal'].showModal()
            this.archiveListObj = list
        },
        async archiveList() {
            try {
                const response = await api.post("/list_delete", { id: this.archiveListObj.id });
                if(response.data.msg === 'ok') {
                    this.$store.dispatch('removeList', this.archiveListObj.id)
                    this.archiveListObj = null
                    this.filterByTag()
                }
            } catch (e) {
                this.$refs.show.showFlashError(e.response.data.msg)
                console.error(e);
            }
        },
        getMembers() {
            if(this.board_id && this.boards) {
                const currentBoard = this.boards.find(board => board.id == this.board_id)
                this.currentUserBoardRole = currentBoard && currentBoard.current_user_role
            }
        },
        fromTaskFalse() {
            this.from_task = false
        },
        formattedTasks(tasks) {
            const updatedTasks = tasks.map(task => {
                let tags = getTagsAsArray(task, this.usersMap, this.tagMap)
                
                return {
                    ...task,
                    tags: tags.map(tag => {
                        return tag.id == this.currentUser?.id ? {
                            ...tag,
                            name: this.currentUser.name,
                            username: this.currentUser.username,
                            bio: this.currentUser.bio,
                        } : tag
                    })
                }
            })

            return updatedTasks
        },
        filterByTag() {
            let boardLists = JSON.parse(JSON.stringify(this.boardLists))
            let resultList = []
            
            if (this.userFilter == 'no-filter') {
                resultList = boardLists
            } else if (this.userFilter == 'non-assigned') {
                resultList = boardLists.map(list => {
                    list.tasks = list.tasks.filter(task => {
                        let tags = typeof task.tags == 'string' ? task.tags.split('|').filter(i => i != '') : task.tags
                        return !task.tags || tags.length === 0
                    })
                    return list
                })
            } else {
                resultList = boardLists.map(list => {
                    list.tasks = list.tasks.filter(task => {
                        if (task.tags && typeof task.tags == 'string') {
                            return task.tags.includes(`user:${this.userFilter}`)
                        } else if (task.tags && Array.isArray(task.tags) && typeof task.tags[0] == 'string') {
                            return task.tags.filter(tag => tag == `user:${this.userFilter}`).length > 0
                        } else if (task.tags && Array.isArray(task.tags) && typeof task.tags[0] == 'object') {
                            return task.tags.filter(tag => tag.id == this.userFilter).length > 0
                        }
                        if(this.newTasks.findIndex(t => t.id == task.id) >= 0) {
                            return this.newTasks.find(t => t.id == task.id)
                        }
                    })
                    return list
                })
            }

            if(this.tagFilter != 'no-filter') {
                resultList = resultList.map(list => {
                    list.tasks = list.tasks.filter(task => {
                        if (task.tags && typeof task.tags == 'string') {
                            return task.tags.includes(`tag:${this.tagFilter}`)
                        } else if (task.tags && typeof task.tags == 'object') {
                            return task.tags.filter(tag => tag.id == this.tagFilter).length > 0
                        }
                        if(this.newTasks.findIndex(t => t.id == task.id) >= 0) {
                            return this.newTasks.find(t => t.id == task.id)
                        }
                    })
                    return list
                })
            }
            
            this.boardListsFiltered = resultList?.slice()
        },
        showUploadState(files, taskID) {
            console.log('showUploadState board')
            console.log(this.$parent)
            this.$parent?.showUploadState(files, taskID)
        },
    },
    watch: {
        async $route(next, prev) {
            if(prev.name == 'TaskModal' && next.name == 'Project') {
                return 
            }
            this.boardsPreload = false;
            await this.tasksSearch();
            await this.getTags();
            this.dragScroll()
        },
        async boards() {
            await this.getTags();
            await this.getMembers()
            this.dragScroll()
        },
        userFilter() {
            this.filterByTag()
        },
        tagFilter() {
            this.filterByTag()
        },
        tasks() {
            this.filterByTag()
        },
        boardLists() {
            if(!this.boardLists || this.boardLists.length == 0) return

            //causes bugs, why do we need it?
            // this.events2.forEach(event => {
            //     this.tasksInterval(event)
            // });
        },
        currentUser() {
            this.getTags()
            this.filterByTag()
        },
        importCSVTasks(val) {
            if(val) this.$refs['import-modal'].showModal()
            else {
                this.$refs['import-modal'].hideModal()
                this.tasksSearch()
            }
        },
        tasksIntervalRun: {
            handler(newVal) {
                if(newVal?.event && newVal?.afterLoad) {
                    this.tasksInterval(newVal.event, newVal.afterLoad)
                }
            },
            deep: true
        }
     }
};
</script>

<style lang="scss">
.board-root {
    &.board-container {
        display: flex;
        align-items: flex-start;
        justify-content: stretch;
    }
    .loading-tasks {
        font-size: 25px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        min-height: 100px;
        padding: 0 20px;
        color: #fff;
    }
    .smooth-dnd-container {
        min-height: 5px;
    }
    .smooth-dnd-container.lists {
        min-height: 100%;
        user-select: none;
    }

    .drop-down-style select {
        border-radius: 0.5rem;
        display: block;
        padding: 0.625rem;
        background-color: rgb(249, 250, 251);
        border: 1px solid rgb(209, 213, 219);
        color: rgb(17, 24, 39);
        font-size: 18px;
        margin-bottom: 16px;
    }

    .card-body {
        padding: 6px !important;
        width: 100%;
        min-height: 50px;
        flex: 1 1 auto;

        a {
            font-size: 12px;
        }
    }

    .card-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: none !important;
        position: relative;
    }

    .smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper {
        overflow: visible;
        display: block;
    }
    .smooth-dnd-container.horizontal > .smooth-dnd-draggable-wrapper {
        height: fit-content;
    }

    .card-body:hover .btn-custom {
        color: #000;
        background-color: transparent !important;
        border: none !important;
    }

    /* file  preview size */


    .root {
        padding: 8px !important;
        overflow: hidden !important;
    }

    .btn-split {
        display: flex !important;
        justify-content: space-between;
        padding: 0 !important;
    }

    .btn-split span {
        padding: 4px 8px;
        flex-grow: 1;
        text-align: left;
    }

    .btn-split span:last-of-type {
        border-left: 1px solid #fff;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
        flex-grow: 0;
        flex-shrink: 1;
        text-align: center;
        min-width: 40px;
    }

    .list-heading {
        padding: 15px 15px 10px;
        border-bottom: 0.5px solid var(--outline);
        display: flex;
        align-items: center;
        gap: 6px;

        .list-heading-inner {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
        }

        .corresponding_boards {
            font-size: 14px;
        }
    }

    .new-task {
        .btn-holder {
            display: flex;
            margin: 0 -5px;

            .btn {
                margin: 0 5px;
                min-width: 0;
                flex-grow: 1;
                font-size: 14px;
            }
        }
    }

    .add-list, .add-first-list {
        background: var(--primary-bg);
        .new-list-btns {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 6px;
            .btn {
                min-width: auto;
            }
        }
    }
    .add-first-list {
        margin-left: 20px;
        margin-top: 13px;
        width: 250px;
        padding: 15px;
        background: var(--primary-bg);
        border-radius: 5px;
    }
}
.w-250px {
    width: 250px;
}

.dropmenu-holder {
    position: relative;

}
.dropmenu-list {
    padding: 4px;
    margin: 0;
    list-style: none;

    li {
        padding: 0;

        &.separator {
            margin-top: 5px;
            border-top: 1px solid var(--outline);
            padding-top: 5px;
        }
    }

    span {
        margin-left: 5px;
    }

    a {
        display: flex;
        align-items: center;
        padding: 6px;
        border-radius: 6px;
        line-height: 1.2;

        &:hover {
            background-color: $new-blue;
        }
    }
}

</style>
